export class InviteV2 {

  public id: string = "0";

  public letter_id: any;
  public letter_name: any;
  public letter_subject: any;
  public letter_text: any;
  public event_id: any;
  public event_name: any;
  public context_id: any;
  public member_id: any;
  public member_name: any;
  public member_email: any;

  public date_sent: Date;
  public date_response: Date;
  public accept: boolean;
  public obs: any;
  
  public admin_invite: boolean = false;
  public admin_response: boolean = false;

  public url_back: any;
  public type: string;

  public agenda: any;

  public memberDataCheck: any = {}

  //public archived: boolean = false;

  constructor () { }
}

